import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20fashion%20product%20flat%20lay%20with%20cream%20beige%20linen%20background%2C%20carefully%20arranged%20stylish%20sneakers%2C%20a%20soft%20folded%20cashmere%20sweater%2C%20leather%20accessories%2C%20a%20minimalist%20tote%20bag%2C%20and%20delicate%20jewelry%20pieces%2C%20warm%20natural%20morning%20sunlight%20casting%20gentle%20shadows%2C%20editorial%20product%20photography%20with%20sophisticated%20neutral%20palette%2C%20clean%20harmonious%20composition%20with%20organic%20styling%2C%20high%20end%20aesthetic&width=1800&height=900&seq=hero-main-product-v3-2026&orientation=landscape"
          alt="itaobuyspreadsheet shopping guide with curated fashion products and structured data"
          title="itaobuyspreadsheet - Smart Shopping Spreadsheet Guide"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center lg:items-start gap-12 lg:gap-0">
            <div className="lg:w-[45%] text-center lg:text-left">
              <div className="inline-flex items-center px-4 py-1.5 rounded-full border border-background-50/30 bg-background-50/10 backdrop-blur-sm mb-6">
                <span className="text-xs font-label text-background-50/90 tracking-wider uppercase whitespace-nowrap">
                  Updated Daily &bull; Structured Shopping Data
                </span>
              </div>
              <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 leading-[1.08]">
                The Ultimate<br />
                <span className="italic font-semibold">itaobuyspreadsheet</span><br />
                Guide for Smart<br />
                Online Shopping
              </h1>
              <p className="mt-5 text-sm md:text-base text-background-50/75 leading-relaxed max-w-[480px] mx-auto lg:mx-0 font-label">
                Discover updated itaobuyspreadsheet lists, product comparisons, and structured shopping data designed to help you make faster and smarter buying decisions in 2026.
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3 mt-8 justify-center lg:justify-start">
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-7 py-3.5 bg-primary-500 text-background-50 font-label font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  itaobuy sheet
                  <i className="ri-arrow-right-up-line ml-2"></i>
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-full sm:w-auto px-7 py-3.5 border-2 border-background-50/40 text-background-50 font-label font-medium text-sm rounded-full hover:bg-background-50/10 transition-all duration-300 whitespace-nowrap text-center cursor-pointer"
                >
                  buy it now
                  <i className="ri-external-link-line ml-2"></i>
                </a>
              </div>
              <div className="mt-10">
                <Link
                  to="/blog/itaobuyspreadsheet-guide"
                  className="inline-flex items-center space-x-2 text-sm text-background-50/80 hover:text-background-50 transition-colors font-label cursor-pointer"
                >
                  <span>Read the full itaobuyspreadsheet guide</span>
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            <div className="hidden lg:block lg:w-[55%]"></div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 text-background-50/60 text-xs font-label">
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>Updated Daily</span>
          </span>
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>Structured Data</span>
          </span>
          <span className="flex items-center space-x-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>14 Categories</span>
          </span>
        </div>
      </div>
    </section>
  );
}